import api from './api';
import { PainelExecutivo } from '../types/painelExecutivo';

interface ApiResultVM<T> {
  data: T | null;
  messages: string[];
}

/**
 * Busca os 10 indicadores do painel executivo, calculados ao vivo a partir do banco.
 * Restrito a ROLE_MASTER no back-end (ver PainelExecutivoController).
 */
export const buscarPainelExecutivo = async (): Promise<PainelExecutivo> => {
  const response = await api.get<ApiResultVM<PainelExecutivo>>('/PainelExecutivo/kpis');

  if (!response.data?.data) {
    throw new Error('Painel executivo veio sem dados.');
  }

  return response.data.data;
};
